import { mediaQueries, size } from '@everlywell/leaves';
import { Link } from 'gatsby';
import styled from 'styled-components';

type PromoWrapperProps = {
  row: number;
  column: number;
  span: number;
};

const PromoWrapper = styled(Link)<PromoWrapperProps>`
  text-decoration: none;
  grid-row: ${(props) => props.row + 2};

  /* Rows of 2 or more cards - prevent promo on 1st row */
  ${mediaQueries.forTabletVerticalUp} {
    grid-column: ${(props) => (props.column ? props.column : 1)} / span
      ${(props) => props.span};
    grid-row: ${(props) => (props.row > 1 ? props.row : 2)};
  }
`;

const ImageWrapper = styled.div`
  box-shadow: 0 7px 30px -10px #dce4e5;
  border-radius: ${size.xs3}px;

  .gatsby-image-wrapper-constrained {
    display: flex;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: ${size.lg}px;
  text-decoration: none;

  ${mediaQueries.forPhoneOnly} {
    padding-top: ${size.md}px;
    padding-bottom: 0;
  }
`;

export { PromoWrapper, ImageWrapper, ContentWrapper };
